import { PermissionTypes } from "./PermissionTypes";

export interface IPermissionType {
    permissionTypeId: PermissionTypes;
    code: string;
    label: string;
}
